import { useEffect, useState } from 'react';
import { Button } from '@/components/ui/button';
import { tr } from '@/contexts/LanguageContext';

const KEY = 'lbw_analytics_consent';
const read = () => { try { return window.localStorage.getItem(KEY); } catch { return 'denied'; } };

// SEC-013: PostHog arranca apagado (boot.js); solo se enciende si la persona acepta aquí.
export const AnalyticsConsentBanner = () => {
  const [open, setOpen] = useState(false);
  useEffect(() => { setOpen(!read()); }, []);
  if (!open) return null;
  const decide = (granted) => {
    try { window.localStorage.setItem(KEY, granted ? 'granted' : 'denied'); } catch { /* bloqueado */ }
    const ph = window.posthog;
    if (ph) {
      if (granted) { ph.opt_in_capturing?.(); ph.startSessionRecording?.(); }
      else { ph.opt_out_capturing?.(); }
    }
    setOpen(false);
  };
  return (
    <div role="dialog" aria-live="polite" data-testid="analytics-consent-banner"
         className="fixed inset-x-3 bottom-3 z-[90] mx-auto max-w-xl rounded-xl border border-border bg-background/95 p-4 shadow-lg backdrop-blur">
      <p className="text-sm">{tr("Usamos analítica anónima para mejorar la app. Nunca grabamos lo que escribes. ¿Nos permites medir el uso?")}</p>
      <div className="mt-3 flex justify-end gap-2">
        <Button size="sm" variant="outline" onClick={() => decide(false)} data-testid="analytics-consent-decline">{tr("No, gracias")}</Button>
        <Button size="sm" onClick={() => decide(true)} data-testid="analytics-consent-accept">{tr("Aceptar")}</Button>
      </div>
    </div>
  );
};
